import React, { useState, useEffect } from 'react';
import FormSection from 'components/sales/formSection/formSection';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import { DatePickerInput } from 'rc-datepicker';
import { FormGroup } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import localization from 'assets/localization/localization';
import FileUpload from 'components/sales/fileUpload/fileUpload';

export const AddFollowUpB2b = ({
  data,
  handleValue,
  documentUploadUrl,
  documentUrlData,
  match,
}) => {
  const copResidentialfollowUp = {
    lead_id: match.params.id,
    last_call_date: '',
    interaction_type: '',
    remarks: '',
    status: '',
    next_step: '',
    next_action_date: '',
    expected_closure: '',
    sites_id: '',
    other_emals: '',
    poc_id: '',
    document: '',
  };

  const [copResidentialData, setCopResidentialData] = useState(
    copResidentialfollowUp
  );
  const [leadId, setleadId] = useState();
  const [isFocus1, setIsFous1] = useState(true);
  const [isFocus2, setIsFous2] = useState(false);
  const [isFocus3, setIsFous3] = useState(false);
  const [ListGate, setlistGate] = useState();

  useEffect(() => {
    setleadId(match.params.id);
    setCopResidentialData({ ...copResidentialData, lead_id: leadId });
  }, []);

  useEffect(() => {
    setCopResidentialData({ ...copResidentialData, lead_id: leadId });
  }, [leadId]);

  const handleFormData = () => {
    let isValue = true;
    for (const key in copResidentialData) {
      if (
        key !== 'remarks' &&
        key !== 'sites_id' &&
        key !== 'other_emals' &&
        key !== 'document'
      ) {
        if (!copResidentialData[key]) {
          isValue = false;
        }
      }
    }
    isValue ? handleValue({ ...copResidentialData }) : handleValue(null);
  };

  useEffect(() => {
    handleFormData();
  }, [copResidentialData]);

  useEffect(() => {
    const selectedDate = new Date();
    setCopResidentialData({
      ...copResidentialData,
      last_call_date: selectedDate,
    });
  }, []);

  const handleDateChange = (date, dateString) => {
    const selectedDate = dateString;
    setCopResidentialData({
      ...copResidentialData,
      last_call_date: selectedDate,
    });
  };

  const handleDateHide1 = () => {
    if (!copResidentialData.last_call_date) {
      setIsFous1(true);
    }
  };
  const handleDateHide2 = () => {
    if (!copResidentialData.next_action_date) {
      setIsFous2(true);
    }
  };
  const handleDateHide3 = () => {
    if (!copResidentialData.expected_closure) {
      setIsFous3(true);
    }
  };

  return (
    <FormSection title={localization.addFollowUpDetails}>
      <FormGroup
        className={`date custom_date_picker ${isFocus1 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={handleDateChange}
          onShow={() => setIsFous1(true)}
          onHide={handleDateHide1}
          onClear={() => setIsFous1(false)}
          value={copResidentialData.last_call_date}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="YYYY-MM-DD"
          maxDate={new Date()}
        />
        <label>
          {localization.lastInteractionDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus1 && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>
      <DropDownInput
        data={data && data.interaction_type}
        label={localization.interactionType}
        required
        isStarRequired={true}
        errorMsg={localization.isRequired}
        getIdValue={(val) =>
          setCopResidentialData({
            ...copResidentialData,
            interaction_type: val.id,
          })
        }
      />

      <ConstantInput
        type="text"
        label={localization.NotesRemarks}
        handleChange={(val) => {
          setCopResidentialData({
            ...copResidentialData,
            remarks: val,
          });
        }}
      />
      <DropDownInput
        data={data && data.followup_status}
        label={localization.status}
        required
        isStarRequired={true}
        errorMsg={localization.isRequired}
        getIdValue={(val) =>
          setCopResidentialData({
            ...copResidentialData,
            status: val.id,
          })
        }
      />
      <ConstantInput
        label={localization.nextActionAgenda}
        // regex={Regex.charSpace.test(copResidentialData.next_steps)}
        errorMsg={localization.isRequired}
        handleChange={(val) => {
          setCopResidentialData({
            ...copResidentialData,
            next_step: val,
          });
        }}
        type="text"
        required
        isStarRequired={true}
      />
      <FormGroup
        className={`date custom_date_picker ${isFocus2 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={(date, dateString) => {
            const selectedDate = dateString;
            setCopResidentialData({
              ...copResidentialData,
              next_action_date: selectedDate,
            });
          }}
          onShow={() => setIsFous2(true)}
          onHide={handleDateHide2}
          onClear={() => setIsFous2(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          minDate={new Date()}
        />
        <label>
          {localization.nextFollowUpDate}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus2 && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>

      <FormGroup
        className={`date custom_date_picker ${isFocus3 ? 'active-date' : ''}`}
      >
        <DatePickerInput
          onChange={(date, dateString) => {
            const selectedDate = dateString;
            setCopResidentialData({
              ...copResidentialData,
              expected_closure: selectedDate,
            });
          }}
          onShow={() => setIsFous3(true)}
          onHide={handleDateHide3}
          onClear={() => setIsFous3(false)}
          autoClose
          closeOnClickOutside
          showOnInputClick
          locale="en"
          className="my-custom-datepicker-component"
          required
          format="DD-MM-YYYY"
          displayFormat="DD-MM-YYYY"
          returnFormat="DD-MM-YYYY"
          minDate={new Date()}
        />
        <label>
          {localization.timeLineForClosure}
          <span className="label-star" style={{ color: 'red' }}>
            {' '}
            *{' '}
          </span>
        </label>
        {!isFocus3 && (
          <label className="error date_error">{localization.isRequired}</label>
        )}
      </FormGroup>

      <DropDownInput
        data={data && data.poc_details}
        label={localization.addPOCButton}
        required
        multipule
        errorMsg={localization.isRequired}
        getIdValue={(val) => {
          if (val.length > 0) {
            setCopResidentialData({
              ...copResidentialData,
              poc_id: [val.map((obj) => obj.id)],
            });
          }
        }}
        minDate={new Date()}
      />

      <ConstantInput
        label={localization.siteIds}
        regex={Regex.alphaNumeric.test(copResidentialData.sites_id)}
        errorMsg={
          copResidentialData.sites_id === ''
            ? localization.isRequired
            : localization.alphaNumericError
        }
        handleChange={(val) => {
          setCopResidentialData({
            ...copResidentialData,
            sites_id: val,
          });
        }}
        type="text"
      />
      <ConstantInput
        label={localization.emailAddress}
        regex={Regex.email.test(copResidentialData.other_emals)}
        handleChange={(val) => {
          setCopResidentialData({
            ...copResidentialData,
            other_emals: val,
          });
        }}
        type="text"
      />
      <div className="w-100 mb-20">
        <div className="btn-transparent mr-3 d-inline-block">
          <FileUpload
            id="addFollowupUpload"
            accept=".pdf,.png,.jpg,.jpeg,.doc"
            documentUploadUrl={documentUploadUrl}
            documentUrlData={documentUrlData}
            onChange={(val) =>
              setCopResidentialData({
                ...copResidentialData,
                document: val,
              })
            }
          >
            <span className="btn btn-transparent">
              {localization.uploadSupportingDocument}
            </span>
          </FileUpload>
          &nbsp;
          <label>{localization.supportedFormat}</label>
          {/* <label className={`error ${copResidentialData.document === "" ? "error-block" : ""}`}>{localization.uploadQuotationIsRequired}</label> */}
        </div>
      </div>
    </FormSection>
  );
};
